import { AxiosPromise } from 'axios';

import { IPaymentHistory, IUserContract } from '~/models/Contracts';

import api from './api';

const PaymentHistoryService = {
  getAllHistoric(professionalId: string): AxiosPromise<IPaymentHistory[]> {
    return api.get(
      `/admin/professional/${professionalId}/contract/indexPayments`,
    );
  },

  getOneContract(contractId: string): AxiosPromise<IUserContract[]> {
    return api.get(`/admin/professional/contract/${contractId}/show`);
  },

  editPaymentHistoricStatus(
    contractId: string,
    data: { status: string },
  ): AxiosPromise<IPaymentHistory> {
    return api.patch(
      `/admin/professional/contract/paymentHistory/${contractId}/updateStatus`,
      data,
    );
  },
};

export default PaymentHistoryService;
